import { SET_COLUMN_FILTER, SET_INIT_COLUMN_FILTER } from './mutation-types'
import { dealArr, filterColumn, initFilterColumnByNamespace } from '@/utils/const'

const state = {
  columnsfilter: dealArr(filterColumn, {
    waiting_count: true,
    label: true,
    remark: true,
    userRemark: true,
    channel: true,
    user_tag: true,
    ip: true,
    command: true,
    storage_business_type: true,
    open_status: true,
    submitUserName: true,
    layerName: true,
    renderCamera: true,
    framesRange: true,
    averageDuration: true,
    gpu_model: true,
    gpu_number: true,
    consumption_memory: true,
    isDeleted: true,
    resolution: true,
    mirror_limit: true,
    MAC: true,
    SN: true,
    organizationStructure: true,
    isFirstReCharge: true,
    isFirstSubmit: true,
    munu_restart: true,
  }, { falseKeyIgnorePages: ['userData', 'submitAnalysis'] }),
}

const mutations = {
  [SET_COLUMN_FILTER] (state, payload) {
    let {columns, page} = payload
    state.columnsfilter[page] = columns
  },
  [SET_INIT_COLUMN_FILTER] (state, payload) {
    const { ns, defaultUncheckedColumn } = payload
    state.columnsfilter = initFilterColumnByNamespace(state.columnsfilter, ns, defaultUncheckedColumn)
  },
}

const actions = {
  filterColumns ({commit, state}, payload) {
    commit(SET_COLUMN_FILTER, payload)
  },
  initColumnFilter({commit}, payload) {
    commit(SET_INIT_COLUMN_FILTER, payload)
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
